import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/ProcurementReport/ProcurementReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProcurementReportActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ProcurementReport/ProcurementReport")
	}

	render() {
		return (
			<Activity 
				name="ProcurementReport"
				RenderedComponent={this.RenderedComponent}
				context="ProcurementReport"
				action="ProcurementReport"
                formActions={FormAction}
            />
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProcurementReportActivity)
